export default __webpack_public_path__ + "static/media/contact-image.be32b042.png";